<template>
  <div
    class="not-absolute:relative flex items-center justify-center overflow-hidden"
    :class="[className, {
      'w-24 h-24': sizeString === '24',
      'w-16 h-16': sizeString === '16',
      'w-12 h-12': sizeString === '12',
    }]">
    <DotLottieVue
      :data="lottieJson"
      :style="{
        width: `${sizeString}px`,
        height: `${sizeString}px`,
      }"
      autoplay
      loop/>
  </div>
</template>

<script setup lang="ts">
import { DotLottieVue } from '@lottiefiles/dotlottie-vue';
import { computed } from 'vue';

import loaderBlack from '@/_redesign/shared/lottie/loader-black.json';
import loaderBlue from '@/_redesign/shared/lottie/loader-blue.json';
import loaderDefault from '@/_redesign/shared/lottie/loader-default.json';
import loaderNeutral from '@/_redesign/shared/lottie/loader-neutral.json';
import loaderRed from '@/_redesign/shared/lottie/loader-red.json';
import { IconSize } from '@/_redesign/shared/types/IconSize';
import { ToNumberLike } from '@/_redesign/shared/types/toNumberLike';
import { VueClass } from '@/types/VueClass';

type Color = 'default' | 'red' | 'blue' | 'black' | 'neutral';

const {
  class: className,
  size = 16,
  color = 'default',
} = defineProps<{
  class?: VueClass;
  size?: ToNumberLike<IconSize>;
  color?: Color;
}>();

const Loader: Record<Color, unknown> = {
  black: loaderBlack,
  blue: loaderBlue,
  red: loaderRed,
  default: loaderDefault,
  neutral: loaderNeutral,
};

const sizeString = computed(() => size.toString());
const lottieJson = computed(() => JSON.stringify(Loader[color]));
</script>
